import { crud, http } from "../../../libs/react-mpk/services";

let service = new crud("/");

export const getLogExport = (query) => {
  return http.get(`/api/log_export`, query);
};

export default service;